import { Alert } from '@mantine/core';
import { AlertCircle } from 'lucide-react';

export const InsuranceMissingAlert = () => (
    <Alert color="red" variant="light" icon={<AlertCircle size={16} />} className="border border-red-300">
        <p className="font-semibold">Versicherungsart für Termin fehlt</p>
        <p className="text-sm">Bitte Versicherungsart für diesen Termin auswählen, um fortzufahren.</p>
    </Alert>
);
